import React, { useState, useEffect } from "react";
import { Drawer, IconButton, List } from "@material-ui/core";
import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import PrintOutlinedIcon from "@material-ui/icons/PrintOutlined";
import ListAltOutlinedIcon from "@material-ui/icons/ListAltOutlined";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import { useTheme } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import AccountBalanceOutlinedIcon from "@material-ui/icons/AccountBalanceOutlined";
import SupervisedUserCircleOutlinedIcon from "@material-ui/icons/SupervisedUserCircleOutlined";
import SettingsBackupRestoreOutlinedIcon from "@material-ui/icons/SettingsBackupRestoreOutlined";
import FeedbackOutlinedIcon from "@material-ui/icons/FeedbackOutlined";
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";

import AddBoxOutlinedIcon from "@material-ui/icons/AddBoxOutlined";

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";
import NaturePeopleOutlinedIcon from "@material-ui/icons/NaturePeopleOutlined";
import AssignmentIndOutlinedIcon from "@material-ui/icons/AssignmentIndOutlined";
import Dot from "./components/Dot";

// import NaturePeopleOutlinedIcon from '@material-ui/icons/NaturePeopleOutlined';
// import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
  closeSidebar,
} from "../../context/LayoutContext";
import UnderWriting from "../AmendForms/UnderWriting";
import { hasPermission } from "../../services/hasPermission";

function Sidebar({ location }) {
  var classes = useStyles();
  var theme = useTheme();
  const [uwFormModal, SetUwFormModal] = useState(false);
  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);
  const structure = [
    {
      id: 0,
      label: "Home",
      link: "/app/dashboard",
      icon: <HomeOutlinedIcon />,
    },
    {
      id: 1,
      label: "Users",
      link: "/app/users",
      icon: <PeopleAltOutlinedIcon />,
    },
    {
      id: 2,
      label: "Underwriting",
      link: "/app/ui",
      icon: <NaturePeopleOutlinedIcon />,
      children: [
        {
          id: 21,
          label: "Policy CSR",
          link: "/app/policy/policy-CSR",
          icon: <ListAltOutlinedIcon />,
          disabled: hasPermission(["POLICY CSR"]),
        },
        {
          id: 22,
          label: "Policy Approve",
          link: "/app/policy/policy-approve",
          icon: <ListAltOutlinedIcon />,
          disabled: hasPermission(["APPROVE POLICY"]),
        },
        {
          id: 23,
          label: "Approve Endorsement",
          link: "/app/policy/approve-endorsement",
          icon: <ListAltOutlinedIcon />,
        },
        {
          id: 24,
          label: "Print UW Forms",
          link: "/app/forms",
          isModal: true,
          isLink: "Modal",
          icon: <PrintOutlinedIcon />,
          disabled: hasPermission(["PRINT UND FORMS"]),
        },
        {
          id: 25,
          label: "App Settings",
          link: "/app/settings",
          icon: <SettingsOutlinedIcon />,
          disabled: hasPermission(["MANAGE UNDERWRITING"]),
        },
      ],
    },

    {
      id: 3,
      label: "Claims",
      link: "/app/ui",
      icon: <AssignmentIndOutlinedIcon />,
      children: [
        {
          id: 31,
          label: "Claims CSR",
          link: "/app/claims/claims-CSR",
          icon: <ListAltOutlinedIcon />,
          disabled: hasPermission(["CLAIMS CSR"]),
        },
        {
          id: 32,
          label: "Claims Forms",
          link: "/app/claims/claims-forms",
          icon: <ListAltOutlinedIcon />,
          disabled: hasPermission(["PRINT CLAIMS FORMS"]),
        },

        {
          id: 33,
          label: "Copy files",
          link: "/app/claims/claims-images",
          icon: <FileCopyIcon />,
          disabled: hasPermission(["BULK MAIL"]),
        },
        {
          id: 34,
          label: "First Report",
          link: "/app/claims/fr-CSR",
          icon: <ListAltOutlinedIcon />,
          disabled: hasPermission(["NEW 1ST REPORT", "EDIT 1ST REPORT"]),
        },
        {
          id: 35,
          label: "Providers CSR",
          link: "/app/providers",
          icon: <ListAltOutlinedIcon />,
          disabled: hasPermission(["EDIT PROVIDERS"]),
        },
        {
          id: 36,
          label: "Claims Payments",
          link: "/app/claims/claims-payments",
          icon: <ListAltOutlinedIcon />,
          disabled: hasPermission(["CLAIM PAYMENTS"]),
        },
        // {
        //   id: 37,
        //   label: "Approve PIP Bills",
        //   link: "/app/claims/approve-pip-bills",
        //   icon: <ListAltOutlinedIcon />,
        //   disabled: hasPermission(["APPROVE PIPBILL"]),
        // },
      ],
    },

    {
      id: 4,
      label: "Reporting",
      link: "/app/ui",
      icon: <AssessmentOutlinedIcon />,
      children: [
        {
          id: 41,
          label: "Reports",
          link: "/app/reports",
          isUrl: true,
          icon: <AssessmentOutlinedIcon />,
          isLink: "Report",
        },
      ],
    },
    // {
    //   id: 5,
    //   label: "Accounting",
    //   link: "/app/ui",
    //   icon: <AccountBalanceOutlinedIcon />,
    //   children: [
    //     {
    //       id: 51,
    //       label: "Money Batch",
    //       link: "/app/account/money-batch",
    //       icon: <AddBoxOutlinedIcon />,
    //     },
    //     {
    //       id: 52,
    //       label: "Return Batch",
    //       link: "/app/account/return-batch",
    //       icon: <ExitToAppOutlinedIcon />,
    //     },
    //   ],
    // },
    // {
    //   id: 6,
    //   label: "Admin",
    //   link: "/app/ui",
    //   icon: <SupervisedUserCircleOutlinedIcon />,
    //   children: [
    //     {
    //       id: 61,
    //       label: "Reverse Endorsement",
    //       link: "/app/admin/reverse-endorsement",
    //       icon: <SettingsBackupRestoreOutlinedIcon />,
    //     },
    //     {
    //       id: 62,
    //       label: "Department Complaint",
    //       link: "/app/admin/department-complaints",
    //       icon: <FeedbackOutlinedIcon />,
    //     },
    //   ],
    // },

    {
      id: 7,
      label: "Agents",
      link: "/app/ui",
      icon: <PeopleAltIcon />,
      children: [
        {
          id: 51,
          label: "Agents CSR",
          link: "/app/agents",
          disabled: hasPermission(["AGENT ADDRESS"]),
          icon: <PermIdentityIcon />,
        },
        {
          id: 52,
          label: "Run Statements",
          link: "/app/agents/runStatements",
          disabled: hasPermission(["AGENT ADDRESS"]),
          icon: <PermIdentityIcon />,
        },
        {
          id: 53,
          label: "View Statements",
          link: "/app/agents/viewSatements",
          disabled: hasPermission(["AGENT ADDRESS"]),
          icon: <PermIdentityIcon />,
        },
      ],
    },

    // { id: 8, type: "divider" },

    // {
    //   id: 10,
    //   label: "App Permissions",
    //   link: "/app/permissions",
    //   icon: <LockOutlinedIcon />,
    //   disabled:hasPermission("ROLES PERMISSIONS")
    // },
    // { id: 11, type: "divider" },
  ];
  useEffect(function () {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });
  const handleUWForms = (type, checkLink, disabled) => {
    if (!disabled) {
      if (checkLink === "Report") {
        window.open("http://vm-aains-sql/Reports_Dev/browse/");
      } else if (checkLink === "Modal") {
        SetUwFormModal(type);
      }
    }
  };
  return (
    <>
      <Drawer
        variant={isPermanent ? "permanent" : "temporary"}
        className={classNames(classes.drawer, {
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        })}
        classes={{
          paper: classNames({
            [classes.drawerOpen]: isSidebarOpened,
            [classes.drawerClose]: !isSidebarOpened,
          }),
        }}
        open={isSidebarOpened}
      >
        {/* <div className={classes.toolbar} /> */}
        <div className={classes.mobileBackButton}>
          <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
            <ArrowBackIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          </IconButton>
        </div>
        <List className={classes.sidebarList}>
          {structure.map((link) => (
            <SidebarLink
              hideSideBar={() => closeSidebar(layoutDispatch)}
              key={link.id}
              location={location}
              isSidebarOpened={isSidebarOpened}
              handleUWForms={handleUWForms}
              disabled={link.disabled}
              {...link}
            />
          ))}
        </List>
      </Drawer>
      <UnderWriting open={uwFormModal} modalClose={handleUWForms} />
    </>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);
